// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"709e72f4","576":"3c349887","692":"98ae679f","773":"06538138","964":"3cb06768"}[chunkId] + ".chunk.js";
};